export default {
  init() {
    $('.open-modal').on('click', function(){
      var id = $(this).data('modal');
      $('.modal[data-benefit="'+id+'"]').fadeIn();
      $('body').addClass('overflow-hidden');
    });
    $('.close-modal').on('click', function(){
      $(this).closest('.modal').fadeOut();
      $('body').removeClass('overflow-hidden');
    })
  }
};
